import { footerData } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-background-200 pt-14 md:pt-16 pb-8 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-magic-line text-xl text-accent-400"></i>
              </span>
              <span className="text-lg font-heading text-background-50">非麻瓜漫画</span>
            </div>
            <p className="text-xs leading-relaxed text-background-400 mb-4">
              {footerData.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerData.quickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">{footerData.copyright}</p>
          <span className="text-xs text-background-600">
            Made with <span className="text-accent-400">❤</span> for magic lovers
          </span>
        </div>
      </div>
    </footer>
  );
}